<span
  [ngbTooltip]="tooltip()"
  [routerLink]="routerLink()"
  [queryParams]="queryParams()"
  [fragment]="fragment()"
  class="badge badge-light-primary cursor-pointer badge-primary-hover"
  >{{ count() }}</span
>
